import React from 'react';
import PropTypes from 'prop-types';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import SrModalV2, {
  MODAL_THEME_STACK,
} from 'client/components/SrModalV2/SrModalV2';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFormikField from 'client/components/SrFormikField';

import './SrTourFeedback.less';

const SrTourFeedbackStepStars = ({
  tour,
  listing,
  isSmallScreen,
  formikBag,
  formFields,
  onClose,
}) => {
  return (
    <SrModalV2
      showCloseButton={false}
      closeOnBackgroundClick
      onClose={() => onClose(formikBag.values)}
      padding='0'
      contentMaxWidth={!isSmallScreen ? '375px' : null}
      theme={MODAL_THEME_STACK}
    >
      <div styleName='stepStars'>
        <SrBox
          styleName='propertyImage'
          backgroundImage={`url("${listing.sunroomPhotoUrls[0]}")`}
        />
        <SrBox padding='24px 25px'>
          <SrText font='greycliff' weight='800' align='center' display='block' size='21'>
            How was the tour at <br />
            {listing.addressStreetDisplay}?
          </SrText>
          <SrBox margin='16px 0 24px'>
            <SrText font='greycliff' weight='600' align='center' display='block' size='16' color='grey'>
              {momentWithAustinTimezone(tour).format('dddd, MMMM D [at] h:mm a')}
            </SrText>
          </SrBox>
          <SrFormikField
            formField={formFields.find((formField) => formField.id === 'rating')}
            formikBag={formikBag}
          />
        </SrBox>
      </div>
    </SrModalV2>
  );
};

SrTourFeedbackStepStars.propTypes = {
  tour: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrTourFeedbackStepStars.displayName = 'SrTourFeedbackStepStars';

export default SrTourFeedbackStepStars;
